
const MAIN_NAV_ITEMS = [
  { title: 'For organizers', href: '/services/' },
  { title: 'Events', href: '/events/' },
  { title: 'Create event', href: '/sports/event/new/' },
  { title: 'Our projects', href: '/projects/' },
]

export default MAIN_NAV_ITEMS
